import { render, staticRenderFns } from "./AllCustomers.vue?vue&type=template&id=1edbb452&scoped=true&"
import script from "./AllCustomers.vue?vue&type=script&lang=js&"
export * from "./AllCustomers.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomers.vue?vue&type=style&index=0&id=1edbb452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edbb452",
  null
  
)

export default component.exports